import { LuSearch } from "@/Components/Icons/Icons";
// highlight: true,

export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "PoolIssuePrice",
            label: "Pool Issue Price",
            component: "header",
          },
        ],
        row2: [
          {
            name: "issuesrnotification",
            label: "Notification & Sr. No.",
            component: "text-field",
            disabled:true
          },
          {
            name: "issuessrNo",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              issuesrnotification: "notation",
            },
          },
          {
            name: "issuePriceValue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "issuePriceQuantity",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row3: [
          {
            name: "IGST",
            label: "IGST",
            component: "header",
          },
        ],
        row4: [
          {
            name: "dutyNotation",
            label: "Duty",
            component: "text-field",
            disabled:true

          },
          {
            name: "dutySrNo",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              dutyNotation: "notation",
            },
          },
          {
            name: "dutyPercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",


          },
          {
            name: "RoadInfraaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "dutyLevel",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "dutyQuantity",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "dutyQuantityValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row5: [
          {
            name: "exemptionType",
            label: "Exemption",
            component: "dropdown",
            options: [{
              label: "GST Notn.",
              value: "GST Notn.",
            },
            {
              label: "Customs Notn.",
              value: "Customs Notn.",
            }]
          },
          {
            name: "exemptionNotation",
            component: "text-field",
            disabled:true

          },
          {
            name: "exemptionSrNo",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              exemptionNotation: "notation",
            },
          },
          {
            name: "exemptionPercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "SocialWelfareaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "exemptionLevel",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "exemptionValue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "exemptionQuantityValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row6: [
          {
            name: "exemptionEffectiveDuty",
            label: "Education Cess",
            component: "text-field",
          },
        ],
        row7: [
          {
            name: "Compensation CESS",
            label: "Compensation CESS",
            component: "header",
          },
        ],
        row8: [
          {
            name: "cessdutyNotation",
            label: "Duty",
            component: "text-field",
            disabled:true

          },
          {
            name: "cessdutySrNo",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              cessdutyNotation: "notation",
            },
          },
          {
            name: "cessdutyPercentage",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "cessRoadInfraaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "cessdutyLevel",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "cessdutyQuantity",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "cessdutyQuantityValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row9: [
          {
            name: "cessexemptionType",
            label: "Exemption",
            component: "dropdown",
            options: [{
              label: "GST Notn.",
              value: "GST Notn.",
            },
            {
              label: "Customs Notn.",
              value: "Customs Notn.",
            }]
          },
          {
            name: "cessexemptionNotation",
            component: "text-field",
            disabled:true

          },
          {
            name: "cessexemptionSrNo",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              cessexemptionNotation: "notation",
            },
          },
          {
            name: "cessexemptionPercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "cessSocialWelfareaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "cessexemptionLevel",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "cessexemptionValue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "cessexemptionQuantityValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row10: [
          {
            name: "cessexemptionEffectiveDuty",
            label: "Education Cess",
            component: "text-field",
          },
        ],
      },
    },
  ],
};
